import { AxiosResponse } from "axios";
import EmpresaFaturamento from "../../../Models/Financeiro/Faturamento/EmpresaFaturamento";
import { MutationBasicaParam, QueryBasicaParam } from "../../../Utils/RequisicaoUtilitario";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Axios } from "../../Axios";
import { queryClient } from "../../../App";

export function useEmpresaFaturamentoSalvar({
    onSuccess,
    queryKey,
    ...rest
}: MutationBasicaParam<
    EmpresaFaturamento,
    AxiosResponse<void, any>
>) {
    return useMutation({
        ...rest,
        mutationFn: (empresaFaturamento) => {
            empresaFaturamento.codRegimeTributario = empresaFaturamento.codRegimeTributario > 0 ? empresaFaturamento.codRegimeTributario : (empresaFaturamento.regimeTributario?.codigo ?? 0);
            return Axios.put<void>("financeiro/faturamento/empresaFaturamento", empresaFaturamento);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Financeiro.Faturamento.EmpresaFaturamento.Listar"] });
            queryClient.invalidateQueries({ queryKey: [`Financeiro.Faturamento.EmpresaFaturamento.Buscar.Pessoa.${entrada.codPessoa}`] });
            onSuccess?.(retorno, entrada, context);
        }
    });
}

export function useEmpresaFaturamentoBuscar({
    queryKey,
    codPessoa,
    ...rest
}:QueryBasicaParam<AxiosResponse<EmpresaFaturamento|null>, EmpresaFaturamento|null, { codPessoa:number }>
) {
    return useQuery({
        ...rest,
        queryKey : [`Financeiro.Faturamento.EmpresaFaturamento.Buscar.Pessoa.${codPessoa}`],
        queryFn : () => Axios.get<EmpresaFaturamento|null>(`financeiro/faturamento/empresaFaturamento/${codPessoa}`),
        select : ({ data }) => {
            if (data === null) return null;

            data.dataCriacao = new Date(data.dataCriacao as any);
            data.valoresImpostos = (data.valoresImpostos ?? []).map(m => {
                m.dataCriacao = new Date(m.dataCriacao);
                if (m.valor != null)
                {
                    m.valor.dataCriacao = new Date(m.valor.dataCriacao);
                    m.valor.dataInicial = new Date(m.valor.dataInicial);
                }
                return m;
            });

            return data;
        },
        staleTime : 1000 * 60 * 0.5
    });
}